import { render, staticRenderFns } from "./MenteeSelector.vue?vue&type=template&id=423f4793&scoped=true&"
import script from "./MenteeSelector.vue?vue&type=script&lang=js&"
export * from "./MenteeSelector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "423f4793",
  null
  
)

export default component.exports